import {Component, ViewChild, ElementRef, OnInit, OnDestroy} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import {EmissionService} from 'services/emission.service';
import {DashboardService} from 'services/dashboard.service';
import {NavbarService} from 'services/connectors/navbar.service';
import {Constants} from 'config/constants';
import {environment } from '../../../../environments/environment';
import {Router, ActivatedRoute} from '@angular/router';

@Component({
    selector: 'tpc-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css']
})

export class DashboardComponent implements OnInit, OnDestroy {
    @ViewChild('offsetForm') offsetForm: ElementRef;
    private onGetAverageEmissionSub: Subscription;
    private onChangeCategorySub: Subscription;
    private affiliateName;
    private country;
    terrapassURL = environment.terrapassURL;
    offsetModel = {
        weightNeeded: 0,
        measurementNeeded: 0,
        measurementNeededUnit: '',
        quantity: 1,
        addToCart: 0,
    };
    model;
    mtAvgTotalSelected: any;
    totalCategorySelected: any;
    constantsIndividual = Constants.calculators.individual;

    constructor(protected emissionService: EmissionService,
                protected dashboardService: DashboardService,
                protected activatedRoute: ActivatedRoute,
                protected router: Router,
                protected navbarService: NavbarService
    ) {
        this.model = Object.assign({}, this.dashboardService.getDefaultData());

        if (this.model.calculatorName === this.constantsIndividual) {
            this.mtAvgTotalSelected = this.model.mtAvgTotal;
        } else {
            // calculators which are not individual use not default Units so we switch default value to mT
            this.toggleConfigUnitSymbols();
        }

        this.totalCategorySelected = this.model.totalCategory;

        this.onGetAverageEmissionSub = dashboardService.USAverageEmission$.subscribe((emission: {total, categories}) => this.setAverage(emission));

        this.onChangeCategorySub = navbarService.changeCategory$.subscribe((data) => {
            this.model.config.categoryName = data.categoryName;
            this.model.calculatorName = data.calculatorName;
        });
    }

    ngOnInit() {
        //this.country = this.activatedRoute.queryParams['_value']['country'];
        //console.log("country value is " + this.country);
        this.getAllQueryParams();
    }

    private getAllQueryParams() {

        if (window.location.href.includes('?')) {

            const queryString = window.location.search;

            const urlParams = new URLSearchParams(queryString);

            this.affiliateName = urlParams.get('affiliateName');
            console.log("affiliateName value is " + this.affiliateName);

            this.country = urlParams.get('country');

            console.log("country is " + this.country);

        }

        if(!this.country)
            this.country = "us";

    }

    setAverage(emission: {total, categories}): void {
        this.model.mtAvgTotal.usEmissionAverage = emission.total.usEmissionAverage;

        for (let key in emission.categories) {
            if (emission.categories.hasOwnProperty(key)) {
                this.model.categories[key].usEmissionAverage = emission.categories[key].usEmissionAverage;
            }
        }
    }

    formatNumberToCurrentUnit(num): number {
        if (this.model.config.currentUnitSymbol === 'lbs') {
            return num * this.model.config.POUNDS_MULTIPLIER;
        } else {
            return num * this.model.config.TONNES_MULTIPLIER;
        }
    }

    formatNumberToPounds(num: number): number {
        return num * this.model.config.POUNDS_MULTIPLIER;
    }


    toggleUnit(item: string): string {
        return (item === 'lbs') ? 'mT' : 'lbs';
    }

    toggleConfigUnitSymbols() {
        this.model.config.currentUnitSymbol = this.toggleUnit(this.model.config.currentUnitSymbol);
        this.model.config.alternateUnitSymbol = this.toggleUnit(this.model.config.alternateUnitSymbol);
    }

    toggleEmissionsUnit(e): void {
        e.preventDefault();
        this.toggleConfigUnitSymbols();
    }

    mouseOverGraphCategory(item, graphName: string): void {
        let name = graphName + 'Selected';
        this[name] = item;
    }

    mouseoutGraph(graphName: string): void {
        let name = graphName + 'Selected';
        this[name] = this.model[graphName];
    }

    setVisibility(categoryEmissions: number): string {
        // to hide extra td when browser floors quantity of pixels
        // than one td with width 0% gets width of 1px to fill in the parent container width
        return categoryEmissions > 0 ? 'visible' : 'hidden';
    }

    getCatGraphWidth(categoryEmissions: number, categoryTotalEmission: number): string {
        return Math.round(categoryEmissions / categoryTotalEmission * 100) + '%';
    }

    countGraphWidth(dividend: number, divisor: number): string {
        if (divisor < dividend) {
            return '100%';
        } else {
            return Math.round((dividend / divisor) * 100) + '%';
        }
    }

    buyOffsets(e, selected: string): void {
        e.preventDefault();
        let isIndividualCalculator = this.model.calculatorName === this.constantsIndividual,
            lbs = this.formatNumberToPounds(this.model.totalCategory.totalEmissions),
            weightNeeded = 0,
            measurementNeededUnit = '',
            calculatorID;

        if (selected === 'all') {
            calculatorID = isIndividualCalculator ? '7550' : '7599';
        } else {
            lbs /= 12;
            calculatorID = isIndividualCalculator ? '7565' : '9546';
        }

        if (isIndividualCalculator) {
            weightNeeded = lbs / 1000;
            measurementNeededUnit = '1,000 lbs';
        } else {
            weightNeeded = Math.ceil(lbs / this.model.config.POUNDS_MULTIPLIER);
            measurementNeededUnit = '1 mT';
        }
        this.offsetModel.weightNeeded = weightNeeded;
        this.offsetModel.measurementNeeded = weightNeeded;
        this.offsetModel.measurementNeededUnit = measurementNeededUnit;
        this.offsetModel.quantity = 1;
        this.offsetModel.addToCart = calculatorID;

        if(this.country.includes("uk"))
        {
            this.terrapassURL = environment.terrapassUKURL;
        }
        else
        {
            this.terrapassURL = environment.terrapassURL;
        }
        
        if(this.affiliateName)
        {
            this.affiliateName = "/ref/".concat(this.affiliateName);
            this.terrapassURL = this.terrapassURL.concat(this.affiliateName);
            console.log("URL is " + this.terrapassURL);
        }

        setTimeout(() => {
            this.offsetForm.nativeElement.submit();
        }, 30);
    }

    checkIfIndividualCalculator() {
        if (this.model.calculatorName === this.constantsIndividual) {
            return this.model.mtAvgTotal.usEmissionAverage;
        } else {
            return 0;
        }
    }

    ngOnDestroy() {
        if (this.onGetAverageEmissionSub) {
            this.onGetAverageEmissionSub.unsubscribe();
        }

        if (this.onChangeCategorySub) {
            this.onChangeCategorySub.unsubscribe();
        }
    }
}




// WEBPACK FOOTER //
// ./src/app/components/calculator/dashboard/dashboard.component.ts